import React from 'react';

function Tile({ children }) {
  return (
    <div className="mn_tile">
      {children}
    </div>
  );
}

export default Tile;
